import { render, staticRenderFns } from "./AppUpdateVersionModal.vue?vue&type=template&id=21607fcb&scoped=true&"
import script from "./AppUpdateVersionModal.vue?vue&type=script&lang=js&"
export * from "./AppUpdateVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdateVersionModal.vue?vue&type=style&index=0&id=21607fcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21607fcb",
  null
  
)

export default component.exports